import production from './production';
import staging from './staging';
// import development from './development';

const getConfig = () => {
	console.log(`Loading configuration for: ${window.location.hostname}`);
	switch (window.location.hostname) {
		case 'localhost':
			return staging;
		case 'studio.staging.zender.tv':
			return staging;
		case 'studio.zender.tv':
			return production;
		default:
			return staging;
	}
};

export default getConfig();



// WEBPACK FOOTER //
// ./src/config/index.js